import React from 'react';

import { Space, Tooltip } from 'antd-v5';
import {
  MdFilter2,
  MdFilter3,
  MdFilter4,
  MdFilter5,
  MdFilter6,
  MdFilter7,
  MdFilter8,
  MdFilter9,
  MdFilter9Plus,
} from 'react-icons/md';
import { Text } from 'scouting-ui/lib';

/** Count icons for 2 to 9 values; more use `MdFilter9Plus` */
const COUNT_ICONS = [
  MdFilter2,
  MdFilter3,
  MdFilter4,
  MdFilter5,
  MdFilter6,
  MdFilter7,
  MdFilter8,
  MdFilter9,
];

interface MultiValueLabelProps {
  /** In display order: the first is shown, all of them in the tooltip */
  values: readonly string[];
  /** Shown when there are none */
  empty?: React.ReactNode;
}

/**
 * The first value, plus a count icon whose tooltip lists all of them when
 * there are several (e.g. a person's positions or sub-units in a table cell).
 */
export default function MultiValueLabel(props: MultiValueLabelProps) {
  const { values, empty = '—' } = props;

  if (!values.length) return <>{empty}</>;
  if (values.length < 2) return <>{values[0]}</>;

  const Icon = COUNT_ICONS[values.length - 2] ?? MdFilter9Plus;
  return (
    <Space size={2}>
      <Tooltip
        placement="bottom"
        title={values.map((value, i) => (
          // Two values can share a label (e.g. positions with different ids)
          <div key={`${i}-${value}`}>{value}</div>
        ))}
      >
        <Icon />
      </Tooltip>{' '}
      <Text>{values[0]}</Text>
    </Space>
  );
}
